// Generated from QueryParser.g4 by ANTLR 4.13.2
import { ParseTreeVisitor } from 'antlr4';
/**
 * This interface defines a complete generic visitor for a parse tree produced
 * by `QueryParser`.
 *
 * @param <Result> The return type of the visit operation. Use `void` for
 * operations with no return type.
 */
export default class QueryParserVisitor extends ParseTreeVisitor {
}
